export const NumberValidator = (value: any) => !isNaN(Number(value))
export const PositiveNumberValidator = (value: any) => Number(value) >= 0

export const MaxValueValidator = (maxValue: number) => (value: any) => Number(value) <= maxValue
export const MinValueValidator = (minValue: number) => (value: any) => Number(value) >= minValue
export const DecimalPlacesValidator = (decimalPlaces: number) => (value: any) => {
    const parts = value.split('.')
    return parts.length === 1 || parts[1].length <= decimalPlaces
}
